export const initial = [
  "あ行", "か行", "さ行", "た行", "な行", "は行", "ま行", "や行", "ら行", "わ行", "他"
];

export const kanaList = [
  ["あ", "い", "う", "え", "お", "ア", "イ", "ウ", "エ", "オ", "ヴ", "ｱ", "ｲ", "ｳ", "ｴ", "ｵ"],
  ["か", "き", "く", "け", "こ", "が", "ぎ", "ぐ", "げ", "ご", "カ", "キ", "ク", "ケ", "コ", "ガ", "ギ", "グ", "ゲ", "ゴ", "ｶ", "ｷ", "ｸ", "ｹ", "ｺ"],
  ["さ", "し", "す", "せ", "そ", "ざ", "じ", "ず", "ぜ", "ぞ", "サ", "シ", "ス", "セ", "ソ", "ザ", "ジ", "ズ", "ゼ", "ゾ", "ｻ", "ｼ", "ｽ", "ｾ", "ｿ"],
  ["た", "ち", "つ", "て", "と", "だ", "ぢ", "づ", "で", "ど", "タ", "チ", "ツ", "テ", "ト", "ダ", "ヂ", "ヅ", "デ", "ド", "ﾀ", "ﾁ", "ﾂ", "ﾃ", "ﾄ"],
  ["な", "に", "ぬ", "ね", "の", "ナ", "ニ", "ヌ", "ネ", "ノ", "ﾅ", "ﾆ", "ﾇ", "ﾈ", "ﾉ"],
  ["は", "ひ", "ふ", "へ", "ほ", "ば", "び", "ぶ", "べ", "ぼ", "ぱ", "ぴ", "ぷ", "ぺ", "ぽ", "ハ", "ヒ", "フ", "ヘ", "ホ", "バ", "ビ", "ブ", "ベ", "ボ", "パ", "ピ", "プ", "ペ", "ポ", "ﾊ", "ﾋ", "ﾌ", "ﾍ", "ﾎ"],
  ["ま", "み", "む", "め", "も", "マ", "ミ", "ム", "メ", "モ", "ﾏ", "ﾐ", "ﾑ", "ﾒ", "ﾓ"],
  ["や", "ゆ", "よ", "ヤ", "ユ", "ヨ", "ﾔ", "ﾕ", "ﾖ"],
  ["ら", "り", "る", "れ", "ろ", "ラ", "リ", "ル", "レ", "ロ", "ﾗ", "ﾘ", "ﾙ", "ﾚ", "ﾛ"],
  ["わ", "を", "ん", "ワ", "ヲ", "ン", "ﾜ", "ｦ", "ﾝ"]
];

export const sjSvsList = [
  ["98_11", "身体介護"],
  ["98_12", "重度訪問介護"],
  ["98_13", "行動援護"],
  ["98_15", "同行援護"]
];
